export default __webpack_public_path__ + "src/assets/icn-toast-close.4e761f3c630f3f70c48260cfc5a703e6.svg";